export default function DownloadIcon({ color = "#28282D" }) {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.86524 10.6747C7.88125 10.6951 7.9017 10.7116 7.92505 10.7229C7.9484 10.7342 7.97403 10.7401 8 10.7401C8.02597 10.7401 8.0516 10.7342 8.07495 10.7229C8.0983 10.7116 8.11875 10.6951 8.13476 10.6747L10.5305 7.65554C10.6182 7.54474 10.539 7.38068 10.3957 7.38068H8.8107V0.170455C8.8107 0.0767045 8.73369 0 8.63957 0H7.35615C7.26203 0 7.18503 0.0767045 7.18503 0.170455V7.37855H5.60428C5.46096 7.37855 5.38182 7.54261 5.46952 7.65341L7.86524 10.6747ZM15.8289 9.92898H14.5455C14.4513 9.92898 14.3743 10.0057 14.3743 10.0994V13.3807H1.62567V10.0994C1.62567 10.0057 1.54866 9.92898 1.45455 9.92898H0.171123C0.0770053 9.92898 0 10.0057 0 10.0994V14.3182C0 14.6953 0.305882 15 0.684492 15H15.3155C15.6941 15 16 14.6953 16 14.3182V10.0994C16 10.0057 15.923 9.92898 15.8289 9.92898Z"
        fill={color}
      />
    </svg>
  );
}
